export default __webpack_public_path__ + "static/media/bean-4.9be6d46e.png";